import gql from 'graphql-tag';

export default gql`
  mutation removeByIdCourseCategoryMutation($_id: MongoID!) {
    removeByIdCourseCategoryMutation(_id: $_id) {
      record {
        _id
      }
    }
  }
`;
